import { render, staticRenderFns } from "./AnagraficaRegionaleTestPage.vue?vue&type=template&id=9e087f78"
import script from "./AnagraficaRegionaleTestPage.vue?vue&type=script&lang=js"
export * from "./AnagraficaRegionaleTestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports